import Marquee from "react-fast-marquee";
import { SPONSORS } from "@/data/agenticHackathon";
import HoverLift from "@/components/motion/HoverLift";

function SponsorChip({ name, tag, logo, logoOnly }) {
    if (logoOnly && logo) {
        return (
            <HoverLift className="mx-2 sm:mx-3 inline-flex shrink-0">
                <div className="flex items-center justify-center rounded-2xl border border-black/[0.08] bg-white px-5 py-4 sm:px-8 sm:py-5 shadow-sm min-w-[140px] sm:min-w-[180px] h-[72px] sm:h-[80px] motion-card">
                    <img
                        src={logo}
                        alt={name}
                        className="h-10 sm:h-12 w-auto max-w-[130px] sm:max-w-[160px] object-contain"
                    />
                </div>
            </HoverLift>
        );
    }

    return (
        <HoverLift className="mx-2 sm:mx-3 inline-flex shrink-0">
            <div className="flex items-center gap-3 sm:gap-4 rounded-2xl border border-black/[0.08] bg-white px-4 py-3 sm:px-6 sm:py-4 shadow-sm min-w-[160px] sm:min-w-[200px] motion-card">
                {logo ? (
                    <img
                        src={logo}
                        alt={name}
                        className="h-8 sm:h-10 w-auto max-w-[100px] sm:max-w-[120px] object-contain shrink-0"
                    />
                ) : (
                    <span className="flex h-9 w-9 sm:h-10 sm:w-10 shrink-0 items-center justify-center rounded-xl bg-zinc-950 text-white font-display text-sm font-black">
                        {name.charAt(0)}
                    </span>
                )}
                <div className="text-left min-w-0">
                    <p className="text-xs sm:text-sm font-semibold text-zinc-900 truncate">
                        {name}
                    </p>
                    {tag ? (
                        <p className="text-[10px] sm:text-[11px] font-mono uppercase tracking-wider text-zinc-500 truncate">
                            {tag}
                        </p>
                    ) : null}
                </div>
            </div>
        </HoverLift>
    );
}

export default function SponsorsMarquee() {
    const items = [...SPONSORS, ...SPONSORS];

    return (
        <section
            data-testid="sponsors-marquee"
            className="py-10 sm:py-12 md:py-16 border-y border-black/[0.06] bg-[#FAFAFA] overflow-hidden"
        >
            <p className="text-center text-[10px] sm:text-xs font-mono uppercase tracking-[0.2em] text-zinc-500 mb-6 sm:mb-8 px-4">
                Proudly supported by
            </p>
            <Marquee
                gradient
                gradientColor="#FAFAFA"
                speed={35}
                pauseOnHover
                className="min-h-[88px]"
            >
                {items.map((s, i) => (
                    <SponsorChip
                        key={`${s.name}-${i}`}
                        name={s.name}
                        tag={s.tag}
                        logo={s.logo}
                        logoOnly={s.logoOnly}
                    />
                ))}
            </Marquee>
        </section>
    );
}
